import { Button } from "reactstrap";
import apiClient from "../../../apiClient";
import useUser from "../../../customHooks/useUser";
import { customFetcher, notify } from "../../../utils";
import useSWR from "swr";
import { DocusignEnvelope, IEmployeeFile } from "../../../globals/interfaces";
import VirtualTable from "../../../components/custom/VirtualTable";
import { useEffect, useState } from "react";
import { socket } from "../../../context/socket";
import ViewFile from "../../../components/hr/ViewFile";

export default function Docusign() {
    const { user } = useUser();

    const {
        data,
        mutate
    } = useSWR('/docusign/status', customFetcher<DocusignEnvelope>, {
        fallbackData: []
    });

    const [selectedFile, setSelectedFile] = useState<IEmployeeFile>();
    const [viewFile, setViewFile] = useState(false);

    const test = async () => {
        await apiClient.post(`/docusign/send-employee-form`, {
            "recipientEmail": user.s_email,
            "FirstName": user.s_first_name,
            "LastName": user.s_last_name,
            "JobTitle": user.s_job_title,
            "Email": user.s_email,
            "sentBy": user.s_email,
            "processName": "TEST DOCUSIGN"
        });
        notify('email sent');
        mutate();
    }

    const openFile = async (s_file_name: string) => {
        const res = await apiClient.post('getBlobAccessLink', {
            data: {
                s_file_name,
                s_container: 'docusign'
            }
        });

        // @ts-ignore
        setSelectedFile({
            s_file_name,
            s_file_type: 'DOCUSIGN',
            accessLink: res.data
        });
        setViewFile(true);
    }

    const handleDeleteFile = async () => {
        notify('File cannot be deleted', 'error');
    }

    useEffect(() => {
        const refreshData = () => {
            mutate();
            notify('Data updated');
        }
        socket.on('DOCUSING_ENVELOPE_COMPLETED', refreshData);

        return () => {
            socket.off('DOCUSING_ENVELOPE_COMPLETED', refreshData);
        }
    }, []);

    return (
        <div>
            <Button onClick={test}>Test Docusign</Button>
            <VirtualTable<DocusignEnvelope>
                data={data}
                mapping={[{
                    name: 'Process Name',
                    value: 'processName'
                }, {
                    name: 'Template ID',
                    value: 'templateId'
                }, {
                    name: 'Recipient Email',
                    value: 'recipientEmail'
                }, {
                    name: 'Recipient Name',
                    value: 'recipientName'
                }, {
                    name: 'Status',
                    value: 'status'
                }, {
                    name: 'Sent by',
                    value: 'sentBy'
                }, {
                    name: 'Sent at',
                    value: 'sentAt',
                    datetime: true,
                    utc: true
                }, {
                    name: 'Completed at',
                    value: 'completedAt',
                    datetime: true,
                    utc: true
                }, {
                    name: 'Last updated',
                    value: 'updatedAt',
                    datetime: true,
                    utc: true
                }, {
                    name: '',
                    icon: true,
                    value: 'fas fa-arrow-down',
                    showCondition: item => item.status === 'COMPLETED',
                    function: item => openFile(item.pdfFileName)
                }]}
            />
            <ViewFile
                modal={viewFile}
                setModal={setViewFile}
                file={selectedFile}
                deleteHrFile={handleDeleteFile}
            />
        </div>
    );
}